import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import {
  getUsers,
  createUser,
  updateUser as updateUserApi,
  deleteUser as deleteUserApi,
  exportUsers,
} from "../../api/modules/users/users.api";
import type {
  GetUsersParams,
  CreateUserDto,
  UpdateUserDto,
} from "../../api/modules/users/users.types";

export const getUser = createAsyncThunk(
  "users/getUser",
  async (params: GetUsersParams | undefined, { rejectWithValue, signal }) => {
    try {
      return await getUsers(params, signal);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addUser = createAsyncThunk(
  "users/addUser",
  async (user: CreateUserDto, { rejectWithValue }) => {
    try {
      const response = await createUser(user);
      toast.success("Usuario creado", { autoClose: 3000 });
      return response;
    } catch (error: any) {
      const raw = error?.raw;
      if (raw?.error && Array.isArray(raw.error)) {
        raw.error.forEach((err: { message: string }) =>
          toast.error(err.message, { autoClose: 3000 })
        );
      } else {
        toast.error(error?.message ?? "Error creando usuario", { autoClose: 3000 });
      }
      return rejectWithValue(error);
    }
  }
);

export const updateUser = createAsyncThunk(
  "users/update",
  async (user: UpdateUserDto, { rejectWithValue }) => {
    try {
      const data = await updateUserApi(user.id, user);
      toast.success("El usuario se actualizó correctamente", { autoClose: 3000 });
      return data;
    } catch (error: any) {
      toast.error(error?.message ?? "Ocurrió un error al actualizar el usuario", { autoClose: 3000 });
      return rejectWithValue(error);
    }
  }
);

export const deleteUser = createAsyncThunk(
  "users/deleteUser",
  async (id: string, { rejectWithValue }) => {
    try {
      await deleteUserApi(id);
      toast.success("El usuario ha sido eliminado con éxito", { autoClose: 2000 });
      return { id };
    } catch (error: any) {
      toast.error(error?.message ?? "Ocurrió un error al eliminar el usuario", { autoClose: 2000 });
      return rejectWithValue(error);
    }
  }
);

export const exportUsersThunk = createAsyncThunk(
  "users/exportUsers",
  async (criteria: Record<string, unknown> | undefined, { rejectWithValue }) => {
    try {
      const blob = await exportUsers(criteria);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "usuarios.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
